import { API } from './api';
import uuid from 'uuid/v4';
import { getLocalStorage, removeLocalStorage, setLocalStorage, LocalStorageKeys, } from 'utility/local-storage';
import { interpreterUids } from '../../index';
import { hasGrowthBookFeature, GrowthBookFeatures } from '../../../core';
export class VoyceService {
    constructor(roomURL, doctor, callSessionInf, institutionId) {
        this.roomURL = roomURL;
        this.doctor = doctor;
        this.callSessionInf = callSessionInf;
        this.institutionId = institutionId;
    }
    async inviteInterpreter(beforeCall = false) {
        if (getLocalStorage(LocalStorageKeys.PRE_INVITE_TOKEN)) {
            removeLocalStorage(LocalStorageKeys.PRE_INVITE_TOKEN);
        }
        const tokenUid = uuid();
        const data = {
            URL: `${this.roomURL}?token=${tokenUid}`,
            Token: tokenUid,
            ClientUserInfo: {
                UserId: this.doctor.userId,
                UserName: this.doctor.username,
                InstitutionId: this.institutionId,
            },
        };
        // eslint-disable-next-line @typescript-eslint/no-shadow
        return API.inviteInterpreter(this.institutionId, data).then((data) => {
            this.preInviteToken = data.PreInviteToken;
            this.invitedInterpreterToken = tokenUid;
            this.configPageUrl = data.URL;
            this.saveSessionInf(beforeCall);
            interpreterUids.push(tokenUid);
            setLocalStorage(LocalStorageKeys.PRE_INVITE_TOKEN, data.PreInviteToken);
            if (hasGrowthBookFeature(GrowthBookFeatures.Voyce)) {
                void API.finishOnDisconnect(this.institutionId, {
                    preInviteToken: data.PreInviteToken,
                });
            }
            return true;
        });
    }
    async stopInterpreterSession(interpreterToken) {
        const preInviteToken = this.getPreInviteToken();
        if (!preInviteToken)
            return;
        const response = await API.stopInterpreterSession(this.institutionId, {
            preInviteToken,
        });
        removeLocalStorage(LocalStorageKeys.PRE_INVITE_TOKEN);
        if (interpreterUids.length && interpreterToken) {
            interpreterUids.splice(interpreterUids.indexOf(interpreterToken), 1);
        }
        else {
            interpreterUids.length = 0;
        }
        return response;
    }
    saveSessionInf(beforeCall) {
        const callId = beforeCall ? ' ' : this.callSessionInf.id;
        const body = {
            preInviteToken: this.getPreInviteToken(),
            token: this.invitedInterpreterToken,
            callId,
            ...(this.institutionId && { institutionId: this.institutionId }),
        };
        API.saveSessionInf(this.institutionId, body).then((data) => {
            this.sessionInfId = data.id;
        });
    }
    getStatusByPreInviteToken() {
        return API.getStatusByPreInviteToken(this.institutionId, {
            preInviteToken: this.getPreInviteToken(),
        });
    }
    getConfigPageUrl() {
        return this.configPageUrl;
    }
    getPreInviteToken() {
        return (this.preInviteToken || getLocalStorage(LocalStorageKeys.PRE_INVITE_TOKEN));
    }
    static trackInterpreterSession(institutionId, sessionId, token) {
        void API.trackInterpreterSession(institutionId, {
            sessionId,
            token,
        });
    }
    static trackInterpreterStatus(token, status, roomId, name) {
        void API.trackInterpreterStatus(token, status, roomId, name);
    }
}
